import React from 'react';
import {card, right, images, bgImg, profileImg, left} from "./DCard.module.css";
import dook from "./dook.jpeg";
import pfp from "./pfp.png";


const DCard = () => {
    return (
        <div className={card}>
            <div className={left}>
                <div className={images}>
                    <img className={bgImg} src={dook}></img>
                    <img className={profileImg} src={pfp}></img>

                </div>
                <div className="info">
                    <div>
                        Mary V. Jiang <br></br>
                        Comp Sci + Visual Media Studies
                    </div>
                </div>
            </div>

            <div className={right}>
                Go Blue Devils
            </div>

        </div>
    )
}

export default DCard;